module.exports = __webpack_public_path__ + "static-portal/img/ba.5dff8cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/ba.png
// module id = 165d
// module chunks = 4